var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
export var Document = svgIcon(function (props) { return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { d: "M18.1396 20H3.25586V0H14.9721L18.1396 3.69767V20ZM4.65121 18.6047H16.7442V4.2093L14.3303 1.39535H4.65121V18.6047Z", fill: "currentColor" }),
    React.createElement("path", { d: "M14.4185 6.5116H6.97668V7.90695H14.4185V6.5116Z", fill: "currentColor" }),
    React.createElement("path", { d: "M14.4185 9.30231H6.97668V10.6977H14.4185V9.30231Z", fill: "currentColor" }),
    React.createElement("path", { d: "M10.6976 12.093H6.97668V13.4884H10.6976V12.093Z", fill: "currentColor" }))); });
//# sourceMappingURL=Document.js.map